(($, Drupal) => {
  "use strict";

  const closeDialog = (() => {
    const $html = $("html");
    const $body = $("body");

    // Toggles the 'dialog-open' class based on dialog visibility
    const toggleDialogOpenClass = () => {
      const isDialogVisible =
        $(".ui-dialog:visible").length > 0 || $body.hasClass("modal-open");
      $html.toggleClass("dialog-open", isDialogVisible);

      if (!isDialogVisible) {
        $html.add($body).removeAttr("style");
      }
    };

    const handleCloseButtonClick = () => {
      $html.removeClass("dialog-open");
      $html.add($body).removeAttr("style");
    };

    // Attach event handlers for dialog events and specific close buttons
    // Initializes event handlers for dialog open and close events:
    // - Toggles the `dialog-open` class when dialogs open or close.
    // - Delays the toggle update slightly when dialog close buttons are clicked
    //   to ensure the DOM state reflects the change.
    const initializeDialogEventHandlers = () => {
      $(document)
        .off("dialogopen dialogclose", ".ui-dialog", toggleDialogOpenClass)
        .on("dialogopen dialogclose", ".ui-dialog", toggleDialogOpenClass)
        .off("click", ".ui-dialog-titlebar-close, .modal-header .btn-close, .annotations__close-modal", handleCloseButtonClick)
        .on("click", ".ui-dialog-titlebar-close, .modal-header .btn-close, .annotations__close-modal", handleCloseButtonClick)
        .off("keydown.closeDialog")
        .on("keydown.closeDialog", (e) => {
          if (e.key === "Escape" || e.keyCode === 27) {
            e.preventDefault();
            $(".ui-dialog:visible").each(function () {
              $(this).find(".ui-dialog-titlebar-close").trigger("click");
            });
            if ($body.hasClass("modal-open")) {
              $(".modal-header .btn-close:visible, .annotations__close-modal:visible").first().trigger("click");
            }
            handleCloseButtonClick();
          }
        });
    };

    return () => {
      initializeDialogEventHandlers();
    };
  })();

  // Defines a behavior to manage `dialog-open` class on the `<html>` element
  // based on the visibility of dialogs or modals and to ensure proper styles
  // are applied or removed when dialogs are opened or closed.
  Drupal.behaviors.closeDialog = {
    attach: closeDialog
  };
})(jQuery, Drupal);
